import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';
import { OperationService } from 'src/app/shared/service/operation/operation.service';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-edition-activite-prevue',
  standalone: false,
  templateUrl: './edition-activite-prevue.component.html',
  styleUrl: './edition-activite-prevue.component.scss'
})

export class EditionActivitePrevueComponent {
  isLoading: boolean = false;
  searchTerm: string = '';
  firstProjets: number = 0;
  rowsProjets: number = 10;
  totalRecords: number = 0;
  filteredtems: any = [];
  paginatedProjets = [];
  filteredProjetData: any[] = [];
  actionData: any[] = [];
  detailPdcActions: any = [];
  detailPdcActivites: any = [];
  pdcData: any = [];
  selectedPdc: any = null;
  loadingForPdc:boolean = false;
  listeAnnee:any = [];

  constructor(
    private paramService: ParameterService,
    private operationService: OperationService,
    private ngxService: NgxUiLoaderService,
    private messageService: MessageService,
    private loader: NgxUiLoaderService,
    private localStorage: LocalStorageService,
    private modalService: NgbModal,

  ) { }


  ngOnInit() {
    // this.actionData = this.localStorage.getDetailsPdcAction();
    this.getPdcListe();
  }

  //recupere la liste des PDC
  getPdcListe() {
    this.isLoading === false;
    this.paramService.getPdcItems().subscribe(
      (response: any) => {
        this.pdcData = response.data;
        this.isLoading = true;
        //console.log("this.pdcData", this.pdcData);
      },
      (error) => {
        //console.log("une erreur est survenu", error);
      }
    );
  }//end getPdcListe

  //afficher les actions et activites d'un pdc
  getDetailPdcActions() {
    //check
    if(this.selectedPdc === null || this.selectedPdc === undefined) return;

    //demarrage
    this.loader.start();
    this.loadingForPdc = false
    this.paramService.getPdcRelatedActions(this.selectedPdc.reference).subscribe(
      (response: any) => {
        this.isLoading = false;
        this.loader.stop();
        this.loadingForPdc = false;

        //actions
        this.detailPdcActions = response.data.pdc_actions;
        this.filteredtems = [...this.detailPdcActions];
        if(this.detailPdcActions.length > 0){
          this.listeAnnee = this.detailPdcActions[0].details_pdc_financements_actions;
        }

        //activites
        this.detailPdcActivites = response.data.pdc_activites;

        //console.log("la reposne du webservcie ", this.detailPdcActions);
        this.totalRecords = this.detailPdcActions.length;
        this.updatePaginatedProjets();
      },
      (error: any) => {
        //console.log("une erreur est survenu", error);
       this.messageService.add({ severity: 'error', summary: 'Erreur', detail: error });
       
        this.isLoading = false;
        this.loader.stop();

      }
    )
  }//end getdetailPdcActionsAction

  onPageChangeProjets(event) {
    this.firstProjets = event.first;
    this.rowsProjets = event.rows;
    this.updatePaginatedProjets();
  }

  //filtrage par programme
  filterProjet() {
    const lowerSearchTerm = this.searchTerm.toLowerCase();

    if (!lowerSearchTerm) {
      this.filteredtems = [...this.detailPdcActions];
    } else {
      this.filteredtems = this.detailPdcActions.filter((item: any) => {
        const matchesCode = item.code && item.code.toLowerCase().includes(lowerSearchTerm);
        const matchesLibelle = item.libelle && item.libelle.toLowerCase().includes(lowerSearchTerm);

        return matchesCode || matchesLibelle
      });
    }

    this.totalRecords = this.filteredtems.length;
    this.firstProjets = 0; // Reset to the first page
    this.updatePaginatedProjets();
  }
  // Méthode pour mettre à jour les données paginées des projets
  updatePaginatedProjets() {
    const start = this.firstProjets;
    const end = start + this.rowsProjets;
    this.paginatedProjets = this.filteredtems.slice(start, end);
  }

  close() {
    this.modalService.dismissAll();
  }

  //recuperation des activites par projet
  getListActivitiesByPdcActionId(pdcActionId: number){
     let activitiesList: any[] = [];
     activitiesList = this.detailPdcActivites.filter((x: any) => x.details_pdc_actions_id === pdcActionId);
     return activitiesList;
  }//end getListActivitiesByPdcActionId

    //imprime en pdf et excel
  exportToDocument(typeDoc:any) {

    //controle de donnees
    if(this.selectedPdc === null || this.selectedPdc === undefined){
       this.messageService.add({ severity: 'error', summary: 'Erreur', detail: "Aucun PDC n'est sélectionné" });
      return;
    }
  
    const requestData = {
      type_exportation: typeDoc,
      reference: this.selectedPdc.reference
    };
  
    this.loader.start();
  
    this.paramService.printPdcGlobal(requestData).subscribe(
      (response: Blob) => {
  
        let filename = '';
        let mimeType = '';
  
        if (typeDoc === 'pdf') {
          filename = 'Plan_de_developpement_communale.pdf';
          mimeType = 'application/pdf';
  
          const blob = new Blob([response], { type: mimeType });
          const url = URL.createObjectURL(blob);
  
          // OUVERTURE UNIQUEMENT
          window.open(url, '_blank');
  
        } else {
          filename = 'Plan_de_developpement_communale.xlsx';
          mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  
          const blob = new Blob([response], { type: mimeType });
  
          // TÉLÉCHARGEMENT UNIQUEMENT
          FileSaver.saveAs(blob, filename);
        }
  
        this.loader.stop();
  
        this.messageService.add({
          severity: 'success',
          summary: 'Export réussi',
          detail: `Le fichier ${typeDoc.toUpperCase()} a été généré avec succès`,
          life: 3000
        });
      },
          (error: any) => {
        this.loader.stop();

        if (error.error instanceof Blob) {

          const reader = new FileReader();

          reader.onload = () => {
            try {
              const err = JSON.parse(reader.result as string);

              this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: err.message || 'Téléchargement échoué'
              });

            } catch (e) {
              this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: 'Erreur lors du traitement du message'
              });
            }
          };

          reader.readAsText(error.error);

        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: error.error?.message || 'Téléchargement échoué'
          });
        }
      }
    );
  }//end exportToDocument
}